import React from "react";
import queryString from "query-string";
import PrivateRoute from "PrivateRoutes";
import ContactDetails from "./components";

const contactDetails = ({ location }) => {
	const queryParams = queryString.parse(location.search);
	return (
		<ContactDetails
			contactInfoId={queryParams.id}
			contactId={queryParams.cid}
		/>
	);
};

const routes = () => (
	<PrivateRoute
		exact
		path="/settings/contact/contact-details"
		component={contactDetails}
	/>
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/ContactDetails/routes.jsx